// extracted by mini-css-extract-plugin
export default {"root":"xp1k0m","textContainer":"xbGsXt","isMobile":"rfCmlO","comparisonNode":"ELQCSZ","tooltip":"FJ5_PC"};